module.exports = __webpack_public_path__ + "static/media/plus-cereja.21a48c13.webp";